import { render, staticRenderFns } from "./FolderList.vue?vue&type=template&id=3e8078b9&scoped=true"
import script from "./FolderList.vue?vue&type=script&lang=js"
export * from "./FolderList.vue?vue&type=script&lang=js"
import style0 from "./FolderList.vue?vue&type=style&index=0&id=3e8078b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8078b9",
  null
  
)

export default component.exports